import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isFunction, trigger } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as Cross } from '../../../../../resources/assets/components/DLS_Cross.svg';
import '../color-picker.css';
function ColorInput(props) {
    return (React.createElement("div", { className: "c-color-picker__input" },
        React.createElement("span", { className: "c-color-picker__input-label" }, MessageService.translate(props.label)),
        React.createElement("span", { className: "c-color-picker__input-value" }, props.value ?? ''),
        isFunction(props.onClick) && props.value
            ? React.createElement(Cross, { className: "c-color-picker__reset", onClick: trigger(props.onClick) })
            : null));
}
function ColorForm(props) {
    return (React.createElement("div", { className: "c-color-picker__fields" },
        React.createElement("div", { className: "c-color-picker__fieldset" },
            React.createElement(ColorInput, { label: "tws.color-picker.color", value: props.colorName }),
            React.createElement(ColorInput, { label: "tws.color-picker.shade", value: props.shade })),
        React.createElement("div", null,
            React.createElement(ColorInput, { label: "tws.color-picker.selected", onClick: trigger(props.onClick), value: props.selected }))));
}
export { ColorForm, };
//# sourceMappingURL=color-form.js.map